import React from 'react';
import './loading.less';

/**
 * jelly 加载动画
 * 说明：原实现使用 styled-components，项目未安装该依赖，这里改为 className + less 实现，动画效果保持一致
 *
 * @param {number} size  图标占位尺寸（px，正方形占位，与原 gif 尺寸一致），动画本身按 size × (size / 2) 绘制，默认 40
 * @param {string} color 圆球颜色，默认取 less 里的 --uib-color
 */
const Loading = ({ className, style, size = 40, color, ...rest }) => {
  return (
    <div
      className={className ? `spin_loading_jelly ${className}` : 'spin_loading_jelly'}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        '--uib-size': `${size}px`,
        ...(color ? { '--uib-color': color } : null),
        ...style,
      }}
      {...rest}
    >
      <div className="jelly" />
      <svg width={0} height={0} className="jelly-maker">
        <defs>
          <filter id="uib-jelly-ooze">
            <feGaussianBlur in="SourceGraphic" stdDeviation="6.25" result="blur" />
            <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="ooze" />
            <feBlend in="SourceGraphic" in2="ooze" />
          </filter>
        </defs>
      </svg>
    </div>
  );
}

export default Loading;
